import { REHYDRATE } from 'redux-persist';
import * as types from '../types/productTypes';
import { modamaiTrace } from '../../utils/modamaiTrace';

const initialState = {
  shopCatalogList: [],
  shopCatalogPagination: null,
  shopCatalogLoading: false,
  shopCatalogError: null,
  detail: null,
  detailLoading: false,
  detailError: null,
  homeRail: [],
  homeGrid: [],
  homeLoading: false,
  homeError: null,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SHOP_CATALOG_REQUEST:
      modamaiTrace('productReducer FETCH_SHOP_CATALOG_REQUEST', {
        prevListLen: state.shopCatalogList?.length ?? 0,
      });
      return {
        ...state,
        shopCatalogLoading: true,
        shopCatalogError: null,
      };
    case types.FETCH_SHOP_CATALOG_SUCCESS: {
      const payload = action.payload || {};
      const items = payload.items;
      const nextList = Array.isArray(items) ? items : [];
      modamaiTrace('productReducer FETCH_SHOP_CATALOG_SUCCESS', {
        listLen: nextList.length,
        hasPagination: Boolean(payload.pagination),
      });
      return {
        ...state,
        shopCatalogLoading: false,
        shopCatalogList: Array.isArray(items) ? items : [],
        shopCatalogPagination: payload.pagination ?? null,
        shopCatalogError: null,
      };
    }
    case types.FETCH_SHOP_CATALOG_FAILURE:
      modamaiTrace('productReducer FETCH_SHOP_CATALOG_FAILURE', action.payload);
      return {
        ...state,
        shopCatalogLoading: false,
        shopCatalogError: action.payload ?? 'Failed to load catalog',
      };

    case types.FETCH_PRODUCT_DETAIL_REQUEST:
      modamaiTrace('productReducer FETCH_PRODUCT_DETAIL_REQUEST', {});
      return {
        ...state,
        detailLoading: true,
        detailError: null,
        detail: null,
      };
    case types.FETCH_PRODUCT_DETAIL_SUCCESS:
      modamaiTrace('productReducer FETCH_PRODUCT_DETAIL_SUCCESS', {
        slug: action.payload?.slug,
      });
      return {
        ...state,
        detailLoading: false,
        detail: action.payload,
        detailError: null,
      };
    case types.FETCH_PRODUCT_DETAIL_FAILURE:
      modamaiTrace('productReducer FETCH_PRODUCT_DETAIL_FAILURE', action.payload);
      return {
        ...state,
        detailLoading: false,
        detailError: action.payload ?? 'Failed to load',
        detail: null,
      };

    case types.FETCH_HOME_CATALOG_REQUEST:
      modamaiTrace('productReducer FETCH_HOME_CATALOG_REQUEST', {});
      return {
        ...state,
        homeLoading: true,
        homeError: null,
      };
    case types.FETCH_HOME_CATALOG_SUCCESS: {
      const p = action.payload || {};
      const railArr = Array.isArray(p.rail) ? p.rail : [];
      const gridArr = Array.isArray(p.grid) ? p.grid : [];
      modamaiTrace('productReducer FETCH_HOME_CATALOG_SUCCESS', {
        railLen: railArr.length,
        gridLen: gridArr.length,
      });
      return {
        ...state,
        homeLoading: false,
        homeRail: Array.isArray(p.rail) ? p.rail : [],
        homeGrid: Array.isArray(p.grid) ? p.grid : [],
        homeError: null,
      };
    }
    case types.FETCH_HOME_CATALOG_FAILURE:
      modamaiTrace('productReducer FETCH_HOME_CATALOG_FAILURE', action.payload);
      return {
        ...state,
        homeLoading: false,
        homeError: action.payload ?? 'Failed',
      };

    case types.CLEAR_PRODUCT_DETAIL:
      modamaiTrace('productReducer CLEAR_PRODUCT_DETAIL', {});
      return {
        ...state,
        detail: null,
        detailError: null,
        detailLoading: false,
      };

    /**
     * Product slice is NOT in `persistConfig.whitelist` — do not merge `payload.product` on REHYDRATE.
     * Legacy localStorage blobs may still contain a stale `product` key; merging it after fetch would
     * overwrite fresh API data (race with async rehydration).
     */
    case REHYDRATE:
      return state;

    default:
      return state;
  }
};

export default productReducer;
